import React from 'react';
import { useSelector } from 'react-redux';
import { useNotifications } from '../../hooks/useNotifications';
import OverLimitBanner from './OverLimitBanner';
import { NOTIFICATION_TYPES } from '../../types/notifications';

/**
 * NotificationProvider Component
 * Handles displaying notifications throughout the app
 * Only renders for authenticated users
 */
const NotificationProvider = ({ children }) => {
  // Use Redux directly instead of useAuth to avoid Router dependency
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { 
    notifications, 
    markAsRead, 
    deleteVideo,
    isLoading 
  } = useNotifications();

  // Don't render notifications for unauthenticated users
  if (!isAuthenticated) {
    return children;
  }

  // Get over-limit notifications
  const overLimitNotifications = notifications.filter(
    notification => notification.type === NOTIFICATION_TYPES.OVER_LIMIT_PROMPT
  );

  return (
    <>
      {/* Render over-limit banners */}
      {overLimitNotifications.map(notification => (
        <OverLimitBanner
          key={notification.id}
          notification={notification}
          onClose={markAsRead}
          onDeleteVideo={deleteVideo}
          isLoading={isLoading}
        />
      ))}
      
      {/* Render children */}
      {children}
    </>
  );
};

export default NotificationProvider;
